var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickyarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 66,
    viewBox: "0 0 84 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3066",
    "data-name": "Group 3066",
    transform: "translate(-1783 -849)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 84,
    height: 66,
    rx: 5,
    transform: "translate(1783 849)",
    fill: "#2db9ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Down_Arrow_3_",
    d: "M37.585,59.184a1.594,1.594,0,0,1-1.13-.468L20.468,42.729a1.6,1.6,0,0,1,2.26-2.26L37.585,55.324,52.441,40.468a1.6,1.6,0,0,1,2.26,2.26L38.715,58.715a1.594,1.594,0,0,1-1.13.468Z",
    transform: "translate(1787.415 832.408)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyarrow);
export default __webpack_public_path__ + "static/media/stickyarrow.f471a813592b2a5421f83da5206b8356.svg";
export { ForwardRef as ReactComponent };